
import Vue from 'vue';
import Vuetify, {
  VRow,
  VCol,
  VDialog,
  VCard,
  VFlex,
  VContainer,
  VBtn,
  VLayout,
  VContent,
  VApp,
  VTextField,
  VTextarea,
  VCardTitle,
  VCardActions,
  VCardText,
    VListItem,
    VListItemContent,
    VListItemAvatar,
    VListItemSubtitle,
    VListItemTitle,
} from 'vuetify/lib';

Vue.use(Vuetify, {
  components: {
    VRow,
    VCol,
    VDialog,
    VCard,
    VFlex,
    VLayout,
    VContainer,
    VContent,
    VBtn,
    VApp,
    VTextField,
    VTextarea,
    VCardActions,
    VCardTitle,
    VCardText,
    VListItem,
    VListItemContent,
    VListItemAvatar,
    VListItemSubtitle,
    VListItemTitle,

  },
});

export default new Vuetify({
});
